import { noop } from 'mojito/utils';
import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import IncrementalNumericKeypadView from './incremental-numeric-keypad.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * IncrementalNumericKeypad view that renders Incremental keypad content.
 *
 * @class IncrementalNumericKeypad
 * @name IncrementalView
 * @memberof Mojito.Modules.Keypad.NumericKeypad
 */

/**
 * Callback to notify button click.
 *
 * @param {object} data - Callback data with information of what button is clicked.
 * @callback Mojito.Modules.Keypad.NumericKeypad.IncrementalView.onClick
 */

/**
 * IncrementalNumericKeypad prop types.
 *
 * @property {Mojito.Modules.Keypad.NumericKeypad.IncrementalView.onClick} [onClick = () => {}] - Callback function executes when a keypad button is tapped.
 *
 * @memberof Mojito.Modules.Keypad.NumericKeypad.IncrementalView
 */

const propTypes = {
    onClick: PropTypes.func,
};

const defaultPropTypes = {
    onClick: noop,
};

export default UIView(
    'IncrementalNumericKeypad',
    IncrementalNumericKeypadView,
    propTypes,
    defaultPropTypes
);
